import thunkMiddleware from "redux-thunk";
import promise from "redux-promise-middleware";
import reducer from "./reducer";

import * as globalAction from '../redux/action/GlobalAction.js';
import { notUndefinedAndNull } from "../utils/Validation";
import getToastDetails from "../constants/ToastConstant";
import { configureStore } from '@reduxjs/toolkit'


const customMiddleWare = store => next => action => {
    toggleToast(store, next, action);
    next(action);
}

async function toggleToast(store, next, action) {

    let toastDetails = getToastDetails(action);

    if (notUndefinedAndNull(toastDetails) && notUndefinedAndNull(toastDetails.message)) {
        store.dispatch(globalAction.showErrorToast(toastDetails.message));

        setTimeout(() => {
            store.dispatch(globalAction.resetErrorToast());
            next(action);
        }, 5000);
    }
}

export default function Store(initialState) {
    const store = configureStore({
            reducer:reducer,
            preloadedState: initialState,
            middleware: [promise,thunkMiddleware,customMiddleWare],
        });
    return store;
}
